import { FunctionComponent, ReactElement, ReactNode } from 'react'
import { Grid, Box, SvgIcon, styled } from '@mui/material'
import { Typography } from '@carto/meridian-ds/components'

const IconWrapper = styled(Box, { shouldForwardProp: (prop) => prop !== 'tight' })<{ tight?: boolean }>(
  ({ tight, theme }) => ({
    marginTop: theme.spacing(tight ? 2 : 4),
    marginBottom: theme.spacing(tight ? 0.5 : 2),

    '.MuiSvgIcon-root': {
      fontSize: tight ? theme.spacing(5) : theme.typography.pxToRem(48)
    }
  })
)

const Content = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(1),
  maxWidth: 579,
  textAlign: 'center'
}))

interface EmptyStateProps {
  icon: FunctionComponent
  caption?: ReactElement | string
  content?: ReactElement | string
  children?: ReactNode
  tight?: boolean
  viewBox?: string
}

function EmptyState({ icon, caption, content, children, tight, viewBox = '0 0 48 48' }: EmptyStateProps) {
  return (
    <Grid container direction="column" alignItems="center">
      <IconWrapper tight={tight}>
        <SvgIcon viewBox={viewBox} component={icon} />
      </IconWrapper>
      {caption && (
        <Typography variant={tight ? 'body2' : 'body1'} color="textSecondary" textAlign="center">
          {caption}
        </Typography>
      )}
      {content && (
        <Content variant="body2" color="textSecondary">
          {content}
        </Content>
      )}
      {children && <Box mt={4}>{children}</Box>}
    </Grid>
  )
}

export default EmptyState
